module.exports = __webpack_public_path__ + "img/C9.aac414ff.png";